import React from 'react';

const MostPopularArticlesHeader = ({ title }: { title: string }) => {
  return (
    <h3 className="relative m-0 mr-[30px] border-0 border-b border-solid border-primary-magenta pb-8 font-suisse-neue text-subheadline-md text-black after:absolute after:-bottom-[29px] after:-right-[15px] after:h-[36px] after:w-px after:-rotate-[55deg] after:bg-primary-magenta after:content-[''] lg:mr-6 after:lg:-bottom-[35px] after:lg:-right-[18px] after:lg:h-[44px] dark:text-grayscale-charcoal">
      {title}
    </h3>
  );
};

export default MostPopularArticlesHeader;
